exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-9ed848f0] .el-input.is-disabled .el-input__inner {\n  text-align: left;\n  color: #167de7;\n  font-weight: bold;\n}\n", ""]);

// exports
